import { render } from "./InspectionReport.vue?vue&type=template&id=2e2ae43e&scoped=true"
import script from "./InspectionReport.vue?vue&type=script&lang=js"
export * from "./InspectionReport.vue?vue&type=script&lang=js"

import "./InspectionReport.vue?vue&type=style&index=0&id=2e2ae43e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2ae43e"]])

export default __exports__